// messaging stream: texting facts, delivery status, simulated replies.
export const en: Record<string, string> = {
  "msg.texting": "Texting",
  "msg.state.demo": "Demo",
  "msg.state.live": "Live",
  "msg.state.test": "Test",
  "msg.state.not_connected": "Not connected",
  "msg.state.ready_for_setup": "Ready for setup",
  "msg.sender": "Sender",
  "msg.sender.none": "No live sender configured",
  "msg.allowlist.on": "Demo allowlist on",
  "msg.allowlist.off": "Allowlist off",
  "msg.allowlist.count": "numbers allowed",
  "msg.blocker": "Why texts are not going out",
  "msg.simulated": "Simulated",
  "msg.simulated.help": "Recorded in demo mode. Nothing reached a phone.",
  "msg.simulateReply": "Simulate a customer reply",
  "msg.simulateReply.help": "Demo only: runs the real inbound path (STOP, AYUDA, tasks, suggestions) without a phone.",
  "msg.simulateReply.placeholder": "What the customer texts back…",
  "msg.simulateReply.send": "Record reply",
  "msg.simulateReply.done": "Reply recorded",
  "msg.simulateReply.autoReply": "Auto-reply sent",
  "msg.delivery": "Delivery",
  "msg.delivery.queued": "Queued at carrier",
  "msg.delivery.accepted": "Accepted by Twilio",
  "msg.delivery.sending": "Sending",
  "msg.delivery.sent": "Sent to carrier",
  "msg.delivery.delivered": "Delivered to phone",
  "msg.delivery.undelivered": "Not delivered",
  "msg.delivery.failed": "Failed",
  "msg.delivery.not_sent": "Not sent",
  "msg.delivery.received": "Received from phone",
  "msg.delivery.simulated": "Simulated",
  "msg.error": "Provider error",
  "msg.liveNote": "Live texts only go to opted-in, allowlisted demo participants.",
};

export const es: Record<string, string> = {
  "msg.texting": "Mensajes de texto",
  "msg.state.demo": "Demo",
  "msg.state.live": "En vivo",
  "msg.state.test": "Prueba",
  "msg.state.not_connected": "Sin conexión",
  "msg.state.ready_for_setup": "Listo para configurar",
  "msg.sender": "Remitente",
  "msg.sender.none": "No hay remitente en vivo configurado",
  "msg.allowlist.on": "Lista permitida activa",
  "msg.allowlist.off": "Lista permitida desactivada",
  "msg.allowlist.count": "números permitidos",
  "msg.blocker": "Por qué no salen los textos",
  "msg.simulated": "Simulado",
  "msg.simulated.help": "Registrado en modo demo. No llegó a ningún teléfono.",
  "msg.simulateReply": "Simular respuesta del cliente",
  "msg.simulateReply.help": "Solo demo: usa la ruta real de entrada (ALTO, AYUDA, tareas, sugerencias) sin un teléfono.",
  "msg.simulateReply.placeholder": "Lo que el cliente respondería…",
  "msg.simulateReply.send": "Registrar respuesta",
  "msg.simulateReply.done": "Respuesta registrada",
  "msg.simulateReply.autoReply": "Respuesta automática enviada",
  "msg.delivery": "Entrega",
  "msg.delivery.queued": "En cola en la operadora",
  "msg.delivery.accepted": "Aceptado por Twilio",
  "msg.delivery.sending": "Enviando",
  "msg.delivery.sent": "Enviado a la operadora",
  "msg.delivery.delivered": "Entregado al teléfono",
  "msg.delivery.undelivered": "No entregado",
  "msg.delivery.failed": "Falló",
  "msg.delivery.not_sent": "No enviado",
  "msg.delivery.received": "Recibido del teléfono",
  "msg.delivery.simulated": "Simulado",
  "msg.error": "Error del proveedor",
  "msg.liveNote": "Los textos en vivo solo van a participantes de demo que aceptaron y están en la lista.",
};
